(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["av-countdown"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var section = document.querySelector('section.av-countdown');
    var wrapper = document.querySelector('.av-countdown .content-wrapper[data-end]');
    if (!wrapper) return;

    var parts = (wrapper.dataset.end || '').match(/(\d{4})-(\d{2})-(\d{2})[\sT](\d{2}):(\d{2}):(\d{2})/);
    if (!parts) return;

    var endDate = new Date(+parts[1], +parts[2]-1, +parts[3], +parts[4], +parts[5], +parts[6]);

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function tick() {
      var now = new Date();

      if (now >= endDate) {
        section.style.display = 'none';
        return;
      }

      // Always count down to tonight's midnight, auto-resets each day
      var midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
      var diff = midnight - now;

      var hours = Math.floor(diff / (1000 * 60 * 60));
      var mins  = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      var secs  = Math.floor((diff % (1000 * 60)) / 1000);

      wrapper.querySelector('.hours').textContent = pad(hours);
      wrapper.querySelector('.mins').textContent  = pad(mins);
      wrapper.querySelector('.secs').textContent  = pad(secs);

      setTimeout(tick, 1000);
    }

    tick();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
